/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseTemplateUpdateProtocolQueryVariables = Types.Exact<{
  templateId: Types.Scalars['ID']['input'];
}>;


export type UseTemplateUpdateProtocolQuery = { quoteTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateConnection', edges: Array<{ __typename: 'QuoteTemplateEdge', node: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, hasOverridesDefined: boolean } }> } };


export const UseTemplateUpdateProtocolDocument = gql`
    query UseTemplateUpdateProtocol($templateId: ID!) {
  quoteTemplates(
    limit: 1
    filters: {templateIds: [$templateId], sources: [available]}
  ) {
    ... on QuoteTemplateConnection {
      edges {
        node {
          id
          resolvedAsReadModelVersionNumber
          hasOverridesDefined
        }
      }
    }
  }
}
    `;

/**
 * __useUseTemplateUpdateProtocolQuery__
 *
 * To run a query within a React component, call `useUseTemplateUpdateProtocolQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTemplateUpdateProtocolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTemplateUpdateProtocolQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useUseTemplateUpdateProtocolQuery(baseOptions: Apollo.QueryHookOptions<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables> & ({ variables: UseTemplateUpdateProtocolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables>(UseTemplateUpdateProtocolDocument, options);
      }
export function useUseTemplateUpdateProtocolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables>(UseTemplateUpdateProtocolDocument, options);
        }
export function useUseTemplateUpdateProtocolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables>(UseTemplateUpdateProtocolDocument, options);
        }
export type UseTemplateUpdateProtocolQueryHookResult = ReturnType<typeof useUseTemplateUpdateProtocolQuery>;
export type UseTemplateUpdateProtocolLazyQueryHookResult = ReturnType<typeof useUseTemplateUpdateProtocolLazyQuery>;
export type UseTemplateUpdateProtocolSuspenseQueryHookResult = ReturnType<typeof useUseTemplateUpdateProtocolSuspenseQuery>;
export type UseTemplateUpdateProtocolQueryResult = Apollo.QueryResult<UseTemplateUpdateProtocolQuery, UseTemplateUpdateProtocolQueryVariables>;